import React from 'react';

import AttachmentSlider from './AttachmentSlider';

/** Prevents AttachmentSlider from re-rendering when a parent MobX observer re-renders
 * due to unrelated state changes (e.g. like count updates). Without this, the slider
 * remounts and reloads media every time the parent observes any field change.
 */
const areEqual = (prev, next) => {
  if (prev.maxHeight !== next.maxHeight) return false;
  if (prev.attachments.length !== next.attachments.length) return false;
  return prev.attachments.every(
    (att, i) => att.url === next.attachments[i].url
      && att.type === next.attachments[i].type
      && att.title === next.attachments[i].title,
  );
};

export default React.memo(AttachmentSlider, areEqual);
